import React from 'react';

const Checkbox = ({ label, isSelected, onCheckboxChange, desc }) =>
    <div className="form-check contain">
        <label className="typetitle">
            <input
                type="checkbox"
                name="CTcheckbox"
                checked={isSelected}
                onChange={onCheckboxChange}
                className="form-check-input"
                value={label}
            /> {label}
        </label>
        {desc !== null &&
            <label className="describe">
                <span>
                    {desc}
                </span>
            </label>
        }
    </div>
    ;

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox.js